import script from "./FormReservasi.vue?vue&type=script&setup=true&lang=js"
export * from "./FormReservasi.vue?vue&type=script&setup=true&lang=js"

import "./FormReservasi.vue?vue&type=style&index=0&id=32e29d0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32e29d0e"]])

export default __exports__